// extracted by mini-css-extract-plugin
module.exports = {"bedRoomListItemButtonContainer":"Bedrooms_bedRoomListItemButtonContainer__1tymp","listArrangementDetails":"Bedrooms_listArrangementDetails__3Uumw"};